export enum PaymentPlatformEnum {
  UNKNOWN = 'unknown',
  STRIPE = 'stripe',
}
